/**
 * @generated SignedSource<<3338be9f51da36b84760346c85e5c744>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type taxExemptHelpers_buyer$data = {
  readonly tradeFirm: {
    readonly taxDocumentation: {
      readonly stateDocuments: ReadonlyArray<{
        readonly expirationDate: string | null;
        readonly state: string | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "taxExemptHelpers_buyer";
};
export type taxExemptHelpers_buyer$key = {
  readonly " $data"?: taxExemptHelpers_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"taxExemptHelpers_buyer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "taxExemptHelpers_buyer"
};

(node as any).hash = "83e7d72015a7c4df3246966a699d429a";

export default node;
